import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import type {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {UserAccountType} from "../../user/types/UserAccountType";
import {isValidationError} from "../../utils/isValidationError";
import {reportAuthSuccess} from "../actions/report_auth_success";
import {emailSignUp} from "../api/email_sign_up";
import {saveWizardDraft, setRegistrationAuthMode, setStep} from "../state/registration_flow_slice";
import {trackAmplitudeAuthEvent} from "../tracking/track_amplitude_auth_event";
import {trackRegistrationWizardButtonClick} from "../tracking/track_registration_wizard_events";
import {AuthActionType} from "../types/AuthActionType";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {getRegistrationErrorKind} from "../utils/get_registration_error_kind";
import {clearSmsCodeCooldown} from "../utils/registration_wizard_sms_cooldown";
import {useRegistrationWizardTrackingContext} from "./use_registration_wizard_tracking_context";

interface IUseRegistrationWizardEmailSignUpParams {
    setEmailError: (message: string) => void;
    /** Called once the account is created, before the auth success is reported */
    onSignedUp: () => void;
}

interface IEmailSignUpErrorContext {
    dispatch: IAppDispatch;
    email: string;
    trackingContext: ReturnType<typeof useRegistrationWizardTrackingContext>;
    setEmailError: (message: string) => void;
}

/** An existing account switches the wizard to the login path: the user confirms the phone instead of registering */
const handleEmailSignUpError = (error: unknown, context: IEmailSignUpErrorContext) => {
    const {dispatch, email, trackingContext, setEmailError} = context;
    const errorKind = getRegistrationErrorKind(error);

    if (errorKind === "existing_account") {
        dispatch(saveWizardDraft({email}));
        dispatch(setRegistrationAuthMode({authMode: "login"}));
        trackAmplitudeAuthEvent("logged_in", {
            loginMethod: "internal",
            loginPlacement: trackingContext.authPlacement,
            location: trackingContext.location,
            authPlacement: trackingContext.authPlacement
        });
        dispatch(setStep({step: RegistrationFlowStep.PHONE_COMPLETION}));
        return;
    }

    if (errorKind === "email_invalid" && isValidationError(error)) {
        const emailError = error.appError.fieldErrors.email;

        setEmailError(Array.isArray(emailError) ? emailError.join(", ") : emailError);
        return;
    }

    dispatch(addNotification({notification: defaultAPIErrorNotification}));
};

export const useRegistrationWizardEmailSignUp = (params: IUseRegistrationWizardEmailSignUpParams) => {
    const {setEmailError, onSignedUp} = params;
    const dispatch = useAppDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const trackingContext = useRegistrationWizardTrackingContext();
    const userSource = flowState.userSource ?? UserSource.REGISTRATION;

    const submitEmail = async (rawEmail: string) => {
        const email = rawEmail.trim();
        const isDraftedEmail = email.toLowerCase() === flowState.wizardDrafts.email?.toLowerCase();

        trackRegistrationWizardButtonClick(trackingContext, "rp_auth_continue");

        if (flowState.authMode === "login" && isDraftedEmail) {
            dispatch(setStep({step: RegistrationFlowStep.PHONE_COMPLETION}));
            return;
        }

        if (!isDraftedEmail) {
            clearSmsCodeCooldown("smsLogin");
        }

        try {
            await emailSignUp({email, type: UserAccountType.LOCAL, source: userSource});
        } catch (error) {
            handleEmailSignUpError(error, {dispatch, email, trackingContext, setEmailError});
            return;
        }

        dispatch(saveWizardDraft({email}));
        onSignedUp();
        reportAuthSuccess(
            dispatch,
            {
                method: "email",
                authActionType: AuthActionType.REGISTRATION,
                userSource,
                gtmSourceSection: flowState.gtmSourceSection,
                placement: trackingContext.authPlacement,
                location: trackingContext.location,
                authPlacement: trackingContext.authPlacement
            },
            {registrationMethod: "email"}
        );
    };

    return {submitEmail};
};
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import type {IAppDispatch} from "../../store/store";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {UserAccountType} from "../../user/types/UserAccountType";
import {isValidationError} from "../../utils/isValidationError";
import {reportAuthSuccess} from "../actions/report_auth_success";
import {emailSignUp} from "../api/email_sign_up";
import {saveWizardDraft, setRegistrationAuthMode, setStep} from "../state/registration_flow_slice";
import {trackAmplitudeAuthEvent} from "../tracking/track_amplitude_auth_event";
import {trackRegistrationWizardButtonClick} from "../tracking/track_registration_wizard_events";
import {AuthActionType} from "../types/AuthActionType";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {getRegistrationErrorKind} from "../utils/get_registration_error_kind";
import {clearSmsCodeCooldown} from "../utils/registration_wizard_sms_cooldown";
import {useRegistrationWizardTrackingContext} from "./use_registration_wizard_tracking_context";

interface IUseRegistrationWizardEmailSignUpParams {
    setEmailError: (message: string) => void;
    /** Called once the account is created, before the auth success is reported */
    onSignedUp: () => void;
}

interface IEmailSignUpErrorContext {
    dispatch: IAppDispatch;
    email: string;
    trackingContext: ReturnType<typeof useRegistrationWizardTrackingContext>;
    setEmailError: (message: string) => void;
}

/** An existing account switches the wizard to the login path: the user confirms the phone instead of registering */
const handleEmailSignUpError = (error: unknown, context: IEmailSignUpErrorContext) => {
    const {dispatch, email, trackingContext, setEmailError} = context;
    const errorKind = getRegistrationErrorKind(error);

    if (errorKind === "existing_account") {
        dispatch(saveWizardDraft({email}));
        dispatch(setRegistrationAuthMode({authMode: "login"}));
        trackAmplitudeAuthEvent("logged_in", {
            loginMethod: "internal",
            loginPlacement: trackingContext.authPlacement,
            location: trackingContext.location,
            authPlacement: trackingContext.authPlacement
        });
        dispatch(setStep({step: RegistrationFlowStep.PHONE_COMPLETION}));
        return;
    }

    if (errorKind === "email_invalid" && isValidationError(error)) {
        const emailError = error.appError.fieldErrors.email;

        setEmailError(Array.isArray(emailError) ? emailError.join(", ") : emailError);
        return;
    }

    dispatch(addNotification({notification: defaultAPIErrorNotification}));
};

export const useRegistrationWizardEmailSignUp = (params: IUseRegistrationWizardEmailSignUpParams) => {
    const {setEmailError, onSignedUp} = params;
    const dispatch = useAppDispatch();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const trackingContext = useRegistrationWizardTrackingContext();
    const userSource = flowState.userSource ?? UserSource.REGISTRATION;

    const submitEmail = async (rawEmail: string) => {
        const email = rawEmail.trim();
        const isDraftedEmail = email.toLowerCase() === flowState.wizardDrafts.email?.toLowerCase();

        trackRegistrationWizardButtonClick(trackingContext, "rp_auth_continue");

        if (flowState.authMode === "login" && isDraftedEmail) {
            dispatch(setStep({step: RegistrationFlowStep.PHONE_COMPLETION}));
            return;
        }

        if (!isDraftedEmail) {
            clearSmsCodeCooldown("smsLogin");
        }

        try {
            await emailSignUp({email, type: UserAccountType.LOCAL, source: userSource});
        } catch (error) {
            handleEmailSignUpError(error, {dispatch, email, trackingContext, setEmailError});
            return;
        }

        dispatch(saveWizardDraft({email}));
        onSignedUp();
        reportAuthSuccess(
            dispatch,
            {
                method: "email",
                authActionType: AuthActionType.REGISTRATION,
                userSource,
                gtmSourceSection: flowState.gtmSourceSection,
                placement: trackingContext.authPlacement,
                location: trackingContext.location,
                authPlacement: trackingContext.authPlacement
            },
            {registrationMethod: "email"}
        );
    };

    return {submitEmail};
};
